import classNames from "classnames/bind";
import Image from "common/blocks/Image";
import RichText from "common/blocks/RichText";
import { UseFormRegister } from "react-hook-form";
import { ResolvedImage } from "resolvers/data/imageResolver";
import { checkRichTextIsNotEmpty } from "utils/checkRichTextIsNotEmpty";

import Checkbox from "../Checkbox";
import styles from "./MarketingConsent.module.scss";

const cx = classNames.bind(styles);

export interface MarketingConsentProps {
    primaryText: string;
    secondaryText?: string;
    image?: ResolvedImage;
    register: UseFormRegister<any>;
}

export default function MarketingConsent({
    primaryText,
    secondaryText,
    image,
    register,
}: MarketingConsentProps) {
    return (
        <div className={cx("marketing-consent")}>
            <div className={cx("marketing-consent-content")}>
                <div className={cx("marketing-consent-checkbox")}>
                    <Checkbox {...register("marketingConsent")} id="marketingConsentCheckbox" />
                </div>

                <div>
                    <label htmlFor="marketingConsentCheckbox">
                        <RichText html={primaryText}></RichText>
                    </label>
                    {secondaryText && checkRichTextIsNotEmpty(secondaryText) && (
                        <RichText html={secondaryText}></RichText>
                    )}
                </div>
            </div>

            {image && image.src && (
                <div className={cx("marketing-consent-image")}>
                    <Image src={image.src} alt={image.alt} layout="fill" objectFit="cover" />
                </div>
            )}
        </div>
    );
}
